
import { supabase } from "@/integrations/supabase/client";
import { Subscription } from "@/lib/data";
import { getSubscriptionById } from "./getSubscriptions";

export async function createSubscription(subscriptionData: any): Promise<Subscription> {
  console.log("Subscription service receiving data:", subscriptionData);
  
  // Using type assertion to inform TypeScript that we're intentionally omitting subscription_number
  // as it will be generated by the database trigger
  const insertData = {
    customer_id: subscriptionData.customer_id,
    status: subscriptionData.status,
    activation_date: subscriptionData.activation_date,
    installation_street: subscriptionData.installation_street,
    installation_zip_code: subscriptionData.installation_zip_code,
    installation_city: subscriptionData.installation_city,
    housing_type: subscriptionData.housing_type,
    registered_at: new Date().toISOString(),
    created_by: subscriptionData.created_by || 'system',
    contact_name: subscriptionData.contact_name || null,
    contact_phone: subscriptionData.contact_phone || null,
    contact_email: subscriptionData.contact_email || null,
    alarm_com_id: subscriptionData.alarm_com_id || null,
    prom_avarn: subscriptionData.prom_avarn || null,
    invoice_reference: subscriptionData.invoice_reference || null
    // subscription_number is intentionally omitted as it's generated by the database trigger
  } as any; // Using type assertion to bypass TypeScript's type checking for this object
  
  console.log("Inserting subscription with data:", insertData);
  
  const { data: subscription, error } = await supabase
    .from('subscriptions')
    .insert(insertData)
    .select('subscription_id')
    .single();
  
  if (error) {
    console.error('Error creating subscription:', error);
    throw new Error(`Failed to create subscription: ${error.message}`);
  }
  
  console.log("Subscription created with ID:", subscription.subscription_id);
  
  const subscriptionId = subscription.subscription_id;
  
  if (subscriptionData.services && subscriptionData.services.length > 0) {
    console.log("Adding services to subscription:", subscriptionData.services);
    
    const serviceInserts = subscriptionData.services.map((service: any) => ({
      subscription_id: subscriptionId,
      service_id: service.service_id,
      status: 'registered',
      registration_date: new Date().toISOString(),
      activation_date: subscriptionData.activation_date,
      price: service.price
    }));
    
    console.log("Service inserts:", serviceInserts);
    
    const { error: servicesError } = await supabase
      .from('subscription_services')
      .insert(serviceInserts);
      
    if (servicesError) {
      console.error('Error creating subscription services:', servicesError);
      throw new Error(`Failed to create subscription services: ${servicesError.message}`);
    }
  }
  
  return getSubscriptionById(subscriptionId) as Promise<Subscription>;
}
